import React, { memo, useEffect } from 'react';
import { shallowEqual } from 'react-redux';
import { useChatPlayContext } from '@provider/ChatPlayProvider';
import {
  MusicOnBtn,
  MusicOffBtn,
  SoundEffectOnBtn,
  SoundEffectOffBtn,
  SoundTTSOnBtn,
  SoundTTSOffBtn,
} from 'public/assets';
import { css } from '@emotion/react';
import { useAppSelector } from '@store/hooks';
import { RootState } from '@store/store';
import usePlayAudio from '@hooks/usePlayAudio';

const SoundComponents = () => {
  const { playChapterInfo } = useAppSelector(
    (state: RootState) => state.chapter,
    shallowEqual,
  );

  const [setSoundInfo, playSound, pauseSound, isSoundOn] = usePlayAudio(); // 음향 재생
  const [setBGMInfo, playBGM, pauseBGM, isBGMOn] = usePlayAudio(); // BGM 재생
  const [setTTSInfo, playTTS, pauseTTS, isTTSOn] = usePlayAudio(); // TTS 재생

  const { chatSoundEffect, chatBGM, chatTTS, isTTSOnRef } =
    useChatPlayContext();

  useEffect(() => {
    setSoundInfo(chatSoundEffect);
  }, [chatSoundEffect]);

  useEffect(() => {
    setBGMInfo(chatBGM);
  }, [chatBGM]);

  useEffect(() => {
    setTTSInfo(chatTTS);
  }, [chatTTS]);

  useEffect(() => {
    if (isTTSOnRef) {
      isTTSOnRef.current = isTTSOn === 'on';
    }
  }, [isTTSOn]);

  return (
    <div css={container}>
      {playChapterInfo?.hasBGM && (
        <div
          className="button"
          onClick={(e) => {
            isBGMOn === 'on' ? pauseBGM() : playBGM();
            e.stopPropagation();
          }}
        >
          {isBGMOn === 'on' ? <MusicOnBtn /> : <MusicOffBtn />}
        </div>
      )}
      <div
        className="button"
        onClick={(e) => {
          isSoundOn === 'on' ? pauseSound() : playSound();
          e.stopPropagation();
        }}
      >
        {isSoundOn === 'on' ? <SoundEffectOnBtn /> : <SoundEffectOffBtn />}
      </div>
      {playChapterInfo?.hasTTS && (
        <div
          className="button"
          onClick={(e) => {
            isTTSOn === 'on' ? pauseTTS() : playTTS();
            e.stopPropagation();
          }}
        >
          {isTTSOn === 'on' ? <SoundTTSOnBtn /> : <SoundTTSOffBtn />}
        </div>
      )}
    </div>
  );
};

const container = css`
  position: absolute;
  right: 1em;
  top: 1em;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 10;

  .button {
    cursor: pointer;
  }
`;

export default memo(SoundComponents);
